/* eslint-disable no-useless-escape */
export default {
  status: ['paid', 'unpaid'],
  statusColor: { paid: 'Success', unpaid: 'Warning' },
};
